export const API_BASE_URL = window.location.hostname === 'localhost' ? 'http://localhost:8080' : 'https://jwrtg926vg.execute-api.us-east-1.amazonaws.com'

export const api = {
  async get(endpoint: string, method?: string, body?: any) {
    const request: Record<string, any> = {
      method: method ? method : 'GET',
      headers: {
        ...getAuthHeader(),
      },
    }
    if (body) {
      request['body'] = body
    }


    return fetch(`${API_BASE_URL}${endpoint}`, request);
  },

  async post(endpoint: string, body: any) {
    const headers: Record<string, string> = {
      ...getAuthHeader(),
    };

    let reqBody: any = body;

    if (!(body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
      reqBody = JSON.stringify(body);
    }

    return fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers,
      body: reqBody,
    });
  },

  async sendSQSMessage(s3Key: string, s3Bucket: string, client: string, project: string, tags: string) {
    const body = {
      s3Key,
      s3Bucket,
      client,
      project,
      tags,
    };
    return this.post('/api/sendSQSMessage', body);
  },
};

function getAuthHeader(): { Authorization?: string } {
  const token = localStorage.getItem('token');
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
}
